import { render, staticRenderFns } from "./MirrorBodyDetailsCard.vue?vue&type=template&id=0be0c875&scoped=true&"
import script from "./MirrorBodyDetailsCard.vue?vue&type=script&lang=js&"
export * from "./MirrorBodyDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./MirrorBodyDetailsCard.vue?vue&type=style&index=0&id=0be0c875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0c875",
  null
  
)

export default component.exports